export default __webpack_public_path__ + "static/office1-2x-e5d175f0666b70ebd1b24dd8e49d7403.jpg";